import { useEffect } from 'react';
import LoginForm from './LoginForm';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const currentRoute = window.location.pathname;

  useEffect(() => {
    if (currentRoute != 'login') {
      navigate('/login');
    }
  }, [currentRoute, navigate]);

  return (
    // <div onClick={handleLogin}>
    <>
      <div className="login-page p-0 d-flex justify-content-center align-items-center">
        <LoginForm />
      </div>
    </>
  );
}
